<template>
    <div>
        <div class="form-group">
            <label>Email</label>
            <input class="form-control" type="text" v-model="user.authData.username" @input="checkName()" />
            <div class="small text-danger" v-if="!usernameOk">Email già utilizzata</div>
        </div>
        <div class="form-group">
            <label>Password</label>
            <input class="form-control" type="password" v-model="user.authData.password" v-if="$route.params.identifier == '0'" />
            <div class="d-flex" v-else>
                <input class="form-control" type="password" value="xxxxxxxxxxx" :readonly="true" />
                <button class="btn btn-primary btn-sm" @click="changePassword">
                    Cambia password
                </button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import { ModalServices } from '@/services/ModalServices';
import { LoginClient, UserClient } from '@/services/Services';
import { Options, Vue } from 'vue-class-component';
import store from '@/store';
import { Prop } from 'vue-property-decorator';
import { debounce } from '@/utils/debounce';

@Options({})
export default class authData extends Vue {

    @Prop() user: OM.User;

    declare localValue: OM.AuthData;
    usernameOk: boolean = true;

    created(){
        this.checkName();
    }
    
    changePassword(){
        ModalServices.inputModal("Cambio password", "Inserisci la nuova password", '', '', '', '',
        (value) => {
            UserClient.setPassword(this.user.identifier, value)
            .then(x => {
                ModalServices.alertModal("", "Password salvata");
            })
            .catch(err => {
                ModalServices.alertModal("ATTENZIONE", err);
            });
        })
    }

    debouncer = null;
    checkName(){
        clearTimeout(this.debouncer);
        this.debouncer = setTimeout(() => {
            if(!this.user.authData.username)
                return;
            
            LoginClient.checkUsernameExisting(this.user.authData.username, this.user.identifier, false)
            .then(x => {
                this.usernameOk = !x;
                this.$emit('usernameok', this.usernameOk);
            })
        }, 600);
    }
    
}
</script>
